import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NbBadgeModule, NbButtonModule, NbIconModule } from '@nebular/theme';
import { Observable, combineLatest, map } from 'rxjs';
import { DropshipCart, ShoppingCart } from 'shared';
import { ExclusivesCartService } from '../../../exclusives/exclusives.cart.service';
import { ShopService } from '../../../shop/shop.service';
import { UnifiedCartUIService } from '../unified-cart-ui.service';

@Component({
  selector: 'app-cart-button-unified',
  standalone: true,
  imports: [CommonModule, NbBadgeModule, NbButtonModule, NbIconModule],
  templateUrl: './cart-button-unified.component.html',
  styleUrl: './cart-button-unified.component.scss'
})
export class CartButtonUnifiedComponent implements OnInit {
  readonly totalCount$: Observable<number>;
  private nativeCount = 0;
  private exclusivesCount = 0;

  constructor(
    private readonly ui: UnifiedCartUIService,
    private readonly shop: ShopService,
    private readonly exclusives: ExclusivesCartService
  ) {
    this.totalCount$ = combineLatest([
      this.shop.activeCart$(),
      this.exclusives.activeCart$()
    ]).pipe(
      map(([native, exc]) => {
        this.nativeCount = sumNativeItems(native);
        this.exclusivesCount = sumExclusivesLines(exc);
        return this.nativeCount + this.exclusivesCount;
      })
    );
  }

  ngOnInit(): void {
    // Hydrate the native shop cart on first paint. Without this the badge/drawer
    // stay empty until CartGuard fires (/shop/cart) or addToCart self-inits.
    this.shop.initCartSubscription();
  }

  openDrawer(): void {
    const tab = this.exclusivesCount > this.nativeCount ? 'exclusives' : 'native';
    this.ui.open(tab);
  }
}

function sumNativeItems(cart: ShoppingCart | null | undefined): number {
  if (!cart?.items) return 0;
  return cart.items.reduce((n, item) => n + (item.quantity ?? 0), 0);
}

function sumExclusivesLines(cart: DropshipCart | null | undefined): number {
  if (!cart?.lines) return 0;
  return cart.lines.reduce((n, line) => n + (line.quantity ?? 0), 0);
}
